import React from 'react';
import SectionTitle from '../common/SectionTitle';
import Accordion from '../common/Accordion';

const FAQSection: React.FC = () => {
  const faqItems = [
    {
      id: 'faq-1',
      title: 'What are the eligibility criteria for BVSc admissions in India?',
      content: (
        <p>
          To be eligible for BVSc admissions in India, candidates must have completed 10+2 with Physics, Chemistry, and Biology as mandatory subjects. A minimum aggregate of 50% (45% for reserved categories) is required. Additionally, candidates must qualify in the NEET UG examination, which is the mandatory entrance test for veterinary courses.
        </p>
      )
    },
    {
      id: 'faq-2',
      title: 'How is the NEET exam relevant for BVSc admissions?',
      content: (
        <p>
          NEET (National Eligibility cum Entrance Test) is the mandatory entrance examination for all medical and veterinary courses in India. The same NEET-UG score used for MBBS admissions is utilized for BVSc admissions. Candidates must qualify NEET with a minimum percentile as specified by the Veterinary Council of India to be eligible for counseling and admission.
        </p>
      )
    },
    {
      id: 'faq-3',
      title: 'What is the duration of the BVSc & AH program?',
      content: (
        <p>
          The Bachelor of Veterinary Science and Animal Husbandry (BVSc & AH) program is a 5.5-year professional degree course in India. This includes 5 years of academic study divided into 10 semesters, followed by a 6-month mandatory internship period. The curriculum is designed as per Veterinary Council of India regulations.
        </p>
      )
    },
    {
      id: 'faq-4',
      title: 'What are the career opportunities after completing BVSc?',
      content: (
        <div>
          <p>After completing BVSc, graduates have numerous career opportunities:</p>
          <ul className="list-disc pl-5 mt-2">
            <li>Clinical practice in private or government veterinary hospitals</li>
            <li>Government veterinary services</li>
            <li>Pharmaceutical companies and research</li>
            <li>Wildlife conservation and zoo management</li>
            <li>Livestock management and dairy industry</li>
            <li>Teaching and academics</li>
            <li>Meat and food inspection</li>
            <li>Higher studies (MVSc, PhD) in India or abroad</li>
          </ul>
        </div>
      )
    },
    {
      id: 'faq-5',
      title: 'How can VetEdu Consultants help with my BVSc admission?',
      content: (
        <p>
          VetEdu Consultants provides comprehensive support throughout the admission process. Our services include personalized counseling, assistance with NEET preparation, guidance on college selection based on scores and preferences, complete application assistance, documentation support, and post-admission services. We have partnerships with top veterinary colleges across India and maintain high success rates in securing admissions.
        </p>
      )
    }
  ];

  return (
    <section className="section bg-gray-50">
      <div className="container-custom">
        <SectionTitle 
          title="Frequently Asked Questions" 
          subtitle="Find answers to common questions about BVSc admissions and veterinary education in India."
        />
        
        <div className="max-w-3xl mx-auto">
          <Accordion items={faqItems} />
        </div>
      </div>
    </section>
  );
};

export default FAQSection;